module.exports = __webpack_public_path__ + "img/product_logo.a377d088.png";